import { useState } from 'react';
import { Modal } from '@heroui/react';
import type { TaskPhoto } from '@/store/visitDetailSlice';

interface PhotoGalleryProps {
  photos: TaskPhoto[];
}

export function PhotoGallery({ photos }: PhotoGalleryProps) {
  const [selected, setSelected] = useState<TaskPhoto | null>(null);

  if (photos.length === 0) return null;

  return (
    <>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-4">
        {photos.map((photo) => (
          <button
            key={photo.id}
            type="button"
            onClick={() => setSelected(photo)}
            className="group aspect-square overflow-hidden rounded-[var(--radius)] border border-border focus:outline-none focus-visible:ring-2 focus-visible:ring-focus"
          >
            <img
              src={photo.url}
              alt="Фото задачи"
              loading="lazy"
              className="h-full w-full object-cover transition-transform group-hover:scale-105"
            />
          </button>
        ))}
      </div>
      <Modal.Backdrop
        isOpen={selected !== null}
        onOpenChange={(open) => {
          if (!open) setSelected(null);
        }}
      >
        <Modal.Container size="lg">
          <Modal.Dialog className="sm:max-w-3xl" aria-label="Просмотр фото">
            <Modal.CloseTrigger />
            <Modal.Body className="p-0">
              {selected && (
                <img
                  src={selected.url}
                  alt="Фото задачи"
                  className="max-h-[80vh] w-full rounded-[var(--radius)] object-contain"
                />
              )}
            </Modal.Body>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </>
  );
}
